import { motion, useReducedMotion, type HTMLMotionProps } from "framer-motion";

interface RevealProps extends HTMLMotionProps<"div"> {
  /** Stagger delay in seconds. */
  delay?: number;
  /** Initial vertical offset in px. Default 20. */
  y?: number;
}

/**
 * Scroll-triggered reveal. Fades + slides content up once it enters the
 * viewport. Mirrors the `whileInView` pattern used across HomePage so every
 * public page shares the same motion language.
 */
export function Reveal({ delay = 0, y = 20, children, ...rest }: RevealProps) {
  const reduced = useReducedMotion();
  return (
    <motion.div
      initial={reduced ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.5, delay, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}
